import { Checkbox } from '@fluentui/react';
import React from 'react';

export interface IBwjCheckboxProps {
  id?: string;
  label?: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
}

export const BwjCheckbox: React.FunctionComponent<IBwjCheckboxProps> = (props) => {

  return (
    <Checkbox
      id={props.id}
      label={props.label}
      checked={props.checked}
      onChange={(ev, checked) => { !!props.onChange && props.onChange(checked ?? false); }}
    />
  );
};
